module.exports = __webpack_public_path__ + "static/media/burger.b8503d26.png";